import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as describeImageServices from '@iso/services/speaking/describeImage';

//#region CRUD
export function* getDescribeImage() {
	yield takeLatest(actions.GET_DESCRIBE_IMAGE, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(describeImageServices.getDescribeImage, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_DESCRIBE_IMAGE_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* getDescribeImageDetail() {
	yield takeLatest(actions.GET_DESCRIBE_IMAGE_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(describeImageServices.getDescribeImageDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_DESCRIBE_IMAGE_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesDescribeImage() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_DESCRIBE_IMAGE, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(describeImageServices.createQuesDescribeImage, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateDescribeImageDetail() {
	yield takeLatest(actions.UPDATE_DESCRIBE_IMAGE_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(describeImageServices.updateDescribeImageDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteDescribeImage() {
	yield takeLatest(actions.DELETE_DESCRIBE_IMAGE, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(describeImageServices.deleteDescribeImage, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getDescribeImage),
		fork(getDescribeImageDetail),
		fork(createQuesDescribeImage),
		fork(updateDescribeImageDetail),
		fork(deleteDescribeImage),
	]);
}
